import { set, when, toggle } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import addRestriction from '../actions/addRestriction'
import deleteRestriction from '../actions/deleteRestriction'

const setFileRestriction = () => {
  return function({ props, state }) {
    const { selectedFiles, tags: { showShared } } = state.get('media')
    const files = showShared ? selectedFiles : [props.id]
    files.forEach(id => {
      state.set(`media.files.${id}.restrictionType`, props.restriction)
      state.set(`media.files.${id}.restriction`, {
        message: props.message,
        email: props.email,
        type: props.restriction
      })
    })
  }
}

const unsetRestriction = () => {
  return function({ props, state }) {
    const { selectedFiles, tags: { showShared } } = state.get('media')
    const files = showShared ? selectedFiles : [props.id]

    files.forEach(id => {
      state.set(`media.files.${id}.restrictionType`, null)
      state.set(`media.files.${id}.restriction`, null)
    })
  }
}

export default [
  function resetOthers({ props, state }) {
    const path = 'media.tags.form.restriction.editModeType.tags'
    const restrictions = state.get(path)
    Object.keys(restrictions).forEach(item => {
      if (`${path}.${item}` !== props.path) {
        state.set(`${path}.${item}.selected`, false)
      }
    })
  },
  toggle(state`${props`path`}.selected`),
  when(state`${props`path`}.selected`),
  {
    true: [
      set(props`restriction`, props`value`),
      set(props`email`, state`media.tags.form.restriction.email.value`),
      set(props`message`, state`media.tags.form.restriction.message.value`),
      set(
        state`media.tags.form.restriction.type.currentRestriction`,
        props`restriction`
      ),
      setFileRestriction(),
      addRestriction
    ],
    false: [
      deleteRestriction,
      set(state`media.tags.form.restriction.type.currentRestriction`, null),
      unsetRestriction()
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/toggleRestriction.js